module.exports = __webpack_public_path__ + "static/media/fast_forward.66206815.png";